/**
 * 챌린지 선택 팝업의 검색·필터·정렬 — 순수 함수(2026-10-07). 목록이 작아 화면이 한다(QBase 세션과 정한 것).
 */
export const SORTS = ['recent', 'participants', 'likes', 'name'];

const norm = (s) => String(s || '').toLowerCase();

/**
 * @param rows  ChallengePickerModal 의 merged 행
 * @param f     { q, levels, dbms, scope, onlyMine, onlyLiked, sort }
 *   onlyMine = 「내가 참여한 것」(제출 기록이 있는 것)
 */
export function filterSummaries(rows, f = {}) {
    const q = norm(f.q).trim();
    const out = (rows || []).filter((r) => {
        if (q && !norm(r.name).includes(q) && !norm(r.author).includes(q) && !norm(r.id).includes(q)) return false;
        if (f.levels && f.levels.length && !f.levels.includes(r.level)) return false;
        if (f.dbms && r.dbms !== f.dbms) return false;
        if (f.scope && r.scope !== f.scope) return false;
        if (f.onlyMine && !(r.myQuizCnt > 0)) return false;
        if (f.onlyLiked && r.myLikeYn !== 'Y') return false;
        return true;
    });
    const byName = (a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
    const cmp = {
        // 등록일 최신 → 같으면 이름. 등록일이 없는 것(로컬)은 뒤로
        recent: (a, b) => (String(b.regDt || '').localeCompare(String(a.regDt || ''))) || byName(a, b),
        participants: (a, b) => (b.ptcpUserCnt - a.ptcpUserCnt) || byName(a, b),
        likes: (a, b) => (b.likeCnt - a.likeCnt) || byName(a, b),
        name: byName,
    }[SORTS.includes(f.sort) ? f.sort : 'recent'];
    return out.slice().sort(cmp);
}
